import {cloneDeep} from "lodash";

export default {
  getRoomCBTUser: (state, getters, rootState, rootGetters) => (userId) => {
    if (!userId) {
      userId = rootGetters['user/me'].userId;
    }

    const roomCbtUser = state.roomCBTUserList.find(roomCbtUser => roomCbtUser.userId === userId);
    return roomCbtUser;
  },
  isCompleteCBT: (state, getters, rootState, rootGetters) => (userId) => {
    const roomCbtUser = getters.getRoomCBTUser();
    return roomCbtUser?.endType === 'COMPLETE';
  },
  getUserQuestionList: (state, getters, rootState, rootGetters) => (userId) => {
    const roomCBTQuestionList = state.roomCBT.questionList;
    const roomCbtUser = getters.getRoomCBTUser();
    const roomCBTUserQuestionList = roomCbtUser?.userQuestionList || [];

    const userQuestionList = cloneDeep(roomCBTQuestionList);
    roomCBTUserQuestionList.forEach(userQuestion => {
      const question = userQuestionList?.find(question => question.questionId === userQuestion.questionId);
      if (question) {
        userQuestion.userAnswerList.forEach(userAnswer => {
          const answer = question.answerList.find(answer => answer.answerId === userAnswer.answerId);
          if (answer) {
            answer.correct = true;
          }
        })
      }
    })

    return userQuestionList;
  },
  getCBTLogUserQuestionList: (state, getters, rootState, rootGetters) => (roomCbtUser) => {
    const roomCBTUserQuestionList = roomCbtUser?.userQuestionList || [];
    const roomCBTQuestionList = cloneDeep(getters.getRoomCBTLog().cbt.questionList)
      .map((question, i) => {
        const questionAnswerList = question.answerList.filter(answer => answer.correct)
        const isCorrect = questionAnswerList.length === roomCBTUserQuestionList[i]?.userAnswerList.length &&
          questionAnswerList
            .every(answer => {
              return !!roomCBTUserQuestionList[i]?.userAnswerList.find(_userAnswer => _userAnswer.answerId === answer.answerId);
            })

        question.isCorrect = isCorrect;
        question.answerList = question.answerList.map(answer => {
          answer.correct = false;
          return answer;
        })
        return question;
      })

    const userQuestionList = cloneDeep(roomCBTQuestionList);
    roomCBTUserQuestionList.forEach(userQuestion => {
      const question = userQuestionList?.find(question => question.questionId === userQuestion.questionId);
      if (question) {
        userQuestion.userAnswerList.forEach(userAnswer => {
          const answer = question.answerList.find(answer => answer.answerId === userAnswer.answerId);
          if (answer) {
            answer.correct = true;
          }
        })
      }
    })

    return userQuestionList;
  },
  getRoomProgressCBTUserList: (state) => {
    return state.roomCBTUserList.filter(roomCbtUser => !roomCbtUser.endDate);
  },
  getRoomCompleteCBTUserList: (state) => {
    return state.roomCBTUserList.filter(roomCbtUser => !!roomCbtUser.endDate);
  },
  getRoomCBTLog: (state) => (roomCbtId) => {
    if (!roomCbtId) {
      roomCbtId = state.cbtLog.roomCbtId
    }
    return state.cbtLogList.find(cbtLog => cbtLog.roomCbtId === roomCbtId);
  },
  getRoomCBTLogTotalScore: (state, getters, rootState, rootGetters) => (roomCbtId) => {
    const roomCBTLog = getters.getRoomCBTLog(roomCbtId);
    const totalScore = roomCBTLog?.cbt?.questionList?.reduce((totalScore, question) => {
      return totalScore + question.questionScore;
    }, 0) || 0;

    return totalScore;
  }
}
